<template>
	<div>
		<div class="text-response">
			<div class="response">
				<div class="answer-wrapper">
					<div v-if="!isAnswered" class="no-answer">
						<span>
							Not Answered
						</span>
					</div>
					<UnitPartial
						v-else
						class="line-graph"
						:isSurvey="false"
						:question="question"
						:data="getGraphData"
					></UnitPartial>
					<!-- <div v-else class="not-enabled">
						<span>Not applicable</span>
					</div> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import QuestionResponse from '.'
import { mapActions, mapGetters } from 'vuex'
import LoadingButton from '@/module/component/LoadingButton.vue'
import UnitPartial from './partialResponse/UnitPartial'

export default {
	extends: QuestionResponse,

	data() {
		return {}
	},

	methods: {
	},

	computed: {
		isAnswered() {
			let found = false
			this.oresponse.forEach(res => {
				if (res) found = true
			})
			return found
		},
		getGraphData() {
			let data = []
			this.oresponse.forEach((res, index) => {
				if (res && res.length && res[0].value === this.question.options[0].value) {
					data.push({ 'date': this.questionnaireDate(index), 'value': res[0].answer })
				}
			})
			return data
		}
	},
	
	components: {
		UnitPartial,
		LoadingButton
	}
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
.text-response {
	min-height: 30px;
}
.not-enabled {
	padding: 15px 20px;
	span {
		font-style: normal;
		font-weight: 500;
		font-size: 12px;
		line-height: 20px;
		color: #333333;
	}
}
</style>
